/**
 * 上传 API
 */

import type { HttpClient } from '../http/HttpClient'
import type { UploadTokenResponse } from '../../types/upload'

export class UploadAPI {
  private http: HttpClient

  constructor(http: HttpClient) {
    this.http = http
  }

  /**
   * 获取 OSS 上传凭证
   * @param scene 场景，默认 'image'
   * @param keyType key 类型，默认 2
   */
  async getUploadToken(scene = 'image', keyType = 2): Promise<UploadTokenResponse> {
    const response = await this.http.get<UploadTokenResponse>(
      `/api/v1/files/getAliUploadToken`,
      {
        params: { scene, key_type: keyType }
      }
    )
    return response.data
  }
}
